import React from "react";
import logo from '../assets/mainImg/mainBrown.png'
import { Phone,Mail,ChevronRight } from "lucide-react";

const Footer = ({services,setShowBookingForm})=>{
    return ( <footer className="bg-gradient-to-b from-gray-900 to-black text-white py-12">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                        <div>
                            <div className="flex items-center space-x-3 mb-6 sm:justify-center">
                                <div className="p-3 bg-gradient-to-br from-blue-500 via-cyan-400 to-indigo-500 rounded-xl shadow-lg">
                                    <img src={logo} alt="" className="sm:w-12 h-12"/>
                                </div>
                                <div>
                                    <div className="text-xl font-bold bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
                                        SSK Travels
                                    </div>
                                    <div className="text-gray-400 text-sm">
                                        Premium Travel Services
                                    </div>
                                </div>
                            </div>
                            <p className="text-gray-400 text-sm mb-6 sm:text-center">
                                Professional travel services with transparent
                                pricing and 24/7 availability across India.
                            </p>
                            <div className="flex space-x-3 sm:justify-center">
                                <a
                                    href="tel:9551776782"
                                    className="p-2 bg-gray-800 rounded-lg hover:bg-gradient-to-r hover:from-blue-500 hover:to-cyan-500 transition-all duration-300"
                                >
                                    <Phone className="h-4 w-4" />
                                </a>
                                <a
                                    href="mailto:appu955177672@gmail.com"
                                    className="p-2 bg-gray-800 rounded-lg hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 transition-all duration-300"
                                >
                                    <Mail className="h-4 w-4" />
                                </a>
                            </div>
                        </div>

                        <div className="sm:flex sm:flex-col sm:items-center">
                            <h4 className="text-lg font-bold mb-6 bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent sm:text-center">
                                Services
                            </h4>
                            <ul className="space-y-3">
                                {services.map((service) => (
                                    <li key={service.id}>
                                        <button
                                           
                                            className="text-gray-400 hover:text-white transition-colors flex items-center group hover:translate-x-2 duration-300"
                                        >
                                            <div
                                                className={`w-2 h-2 rounded-full ${service.bgColor} mr-3`}
                                            ></div>
                                            {service.title}
                                            <ChevronRight className="h-3 w-3 ml-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="sm:flex sm:flex-col sm:items-center">
                            <h4 className="text-lg font-bold mb-6 bg-gradient-to-r from-emerald-400 to-teal-300 bg-clip-text text-transparent">
                                Quick Links
                            </h4>
                            <ul className="space-y-3">
                                <li>
                                    <button
                                        onClick={() => setShowBookingForm(true)}
                                        className="text-gray-400 hover:text-cyan-300 transition-colors hover:translate-x-2 duration-300"
                                    >
                                        Book Cab
                                    </button>
                                </li>
                                <li>
                                    <button
                                        
                                        className="text-gray-400 hover:text-purple-300 transition-colors hover:translate-x-2 duration-300"
                                    >
                                        One-Way Drop
                                    </button>
                                </li>
                                <li>
                                    <button
                                        
                                        className="text-gray-400 hover:text-emerald-300 transition-colors hover:translate-x-2 duration-300"
                                    >
                                        Hire Driver
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div className="sm:flex sm:flex-col sm:items-center">
                            <h4 className="text-lg font-bold mb-6 bg-gradient-to-r from-purple-400 to-pink-300 bg-clip-text text-transparent">
                                Contact Us
                            </h4>
                            <ul className="space-y-4">
                                <li className="flex items-center group hover:translate-x-2 duration-300">
                                    <div className="p-2 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg mr-3">
                                        <Phone className="h-4 w-4 text-white" />
                                    </div>
                                    <a
                                        href="tel:9551776782"
                                        className="hover:text-blue-300 transition-colors"
                                    >
                                        <div className="font-semibold">
                                            9551776782
                                        </div>
                                        <div className="text-gray-400 text-sm">
                                            Primary
                                        </div>
                                    </a>
                                </li>
                                <li className="flex items-center group hover:translate-x-2 duration-300">
                                    <div className="p-2 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-lg mr-3">
                                        <Phone className="h-4 w-4 text-white" />
                                    </div>
                                    <a
                                        href="tel:6381714992"
                                        className="hover:text-emerald-300 transition-colors"
                                    >
                                        <div className="font-semibold">
                                            9566696782
                                        </div>
                                        <div className="text-gray-400 text-sm">
                                            Secondary
                                        </div>
                                    </a>
                                </li>
                                <li className="flex items-center group hover:translate-x-2 duration-300">
                                    <div className="p-2 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg mr-3">
                                        <Mail className="h-4 w-4 text-white" />
                                    </div>
                                    <a
                                        href="mailto:appu955177672@gmail.com"
                                        className="hover:text-purple-300 transition-colors"
                                    >
                                        <div className="text-sm">
                                            appu955177672@gmail.com
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-gray-800 pt-8 text-center">
                        <p className="text-gray-400">
                            © {new Date().getFullYear()} SSK Travels. All rights
                            reserved.
                        </p>
                        <p className="text-gray-500 text-sm mt-2">
                            Premium Travel Services • All India Coverage • 24/7
                            Support
                        </p>
                    </div>
                </div>
            </footer>
    )
}


export default Footer;